import {WMeshAxesInformation} from './json-interface';
import {Point2D, Rect} from './geometry';
import {CUtilitDrawing} from './utilit-drawing';

interface MeshDrawingLine {
  xDeb: number;
  yDeb: number;
  xFin: number;
  yFin: number;
}

interface MeshDrawingInfo {
  verticalMeshInfo: WMeshAxesInformation;
  horizontalMeshInfo: WMeshAxesInformation;
  virtualDrawing: boolean;
}

interface HVTotalLength { horizontal: number; vertical: number; }

export class WMeshUtils {

  private static readonly RATIO_MESH = 0.9;
  private static readonly RATIO_INFO = (1 - WMeshUtils.RATIO_MESH);

  public static getHVTotalLength(horizontalAxe: WMeshAxesInformation, verticalAxe: WMeshAxesInformation): HVTotalLength {
    return {
      horizontal: this.getWMeshTotalLength(horizontalAxe, verticalAxe.startValue, verticalAxe.endValue),
      vertical: this.getWMeshTotalLength(verticalAxe, horizontalAxe.startValue, horizontalAxe.endValue)
    };
  }

  public static getWMeshTotalLength(wMeshAxesInforamtion: WMeshAxesInformation,
                                    otherAxesStarValue: number,
                                    otherAxesEndValue: number): number {
    let totalLength = 0;
    if (wMeshAxesInforamtion.nbBar && wMeshAxesInforamtion.step)
      totalLength = ((wMeshAxesInforamtion.nbBar - 1) * wMeshAxesInforamtion.step) + otherAxesStarValue + otherAxesEndValue;
    return totalLength;
  }

  public static isMeshValuesCorrect(meshAxesValue: WMeshAxesInformation): boolean {
      if (isNaN(meshAxesValue.nbBar) || meshAxesValue.nbBar == 0 || meshAxesValue.nbBar > 1000)
          return false;
      if (isNaN(meshAxesValue.step) || meshAxesValue.step == 0)
          return false;
      if (isNaN(meshAxesValue.startValue) || meshAxesValue.startValue == 0)
          return false;
      if (isNaN(meshAxesValue.endValue) || meshAxesValue.endValue == 0)
          return false;

      return true;
  }

  private static getMeshPath2D(meshDrawRect: Rect,
                               verticalMeshValue: WMeshAxesInformation,
                               horizontalMeshValue: WMeshAxesInformation
  ): {Vertical: Path2D, Horizontal: Path2D, verticalLines: MeshDrawingLine[], horizontalLines: MeshDrawingLine[]} {
      const arrayLineVertical: MeshDrawingLine[] = [];
      const arrayLineHorizontal: MeshDrawingLine[] = [];
      const canvasWidth = meshDrawRect.right - meshDrawRect.left;
      const canvasHeight = meshDrawRect.bottom - meshDrawRect.top;

      // un coté de surface pour dessiné les infos
      const paddingX = (canvasWidth * WMeshUtils.RATIO_INFO) / 2 + meshDrawRect.left;
      const paddingY = (canvasHeight * WMeshUtils.RATIO_INFO) / 2 +  meshDrawRect.top;

      const totalLength = WMeshUtils.getHVTotalLength(horizontalMeshValue, verticalMeshValue);
      const totalLengthX = totalLength.vertical;      // Vertical, correspond
      const totalLengthY = totalLength.horizontal;    // Horizontal,

      // On garde 5% du canvas sur chaque coté pour pouvoir desiner des informations en plus
      const meshDrawingX = canvasWidth * WMeshUtils.RATIO_MESH;
      const meshDrawingY = canvasHeight * WMeshUtils.RATIO_MESH;

      function scaleMeshDrawingLines(meshDrawingLines: MeshDrawingLine[]): MeshDrawingLine[] {
        const result: MeshDrawingLine[] = [];
        meshDrawingLines.forEach((value, index) => {
          const scaledXDeb = paddingX + (value.xDeb * meshDrawingX / totalLengthX);
          const scaledYDeb = paddingY + (value.yDeb * meshDrawingY / totalLengthY);
          const scaledXFin = paddingX + (value.xFin * meshDrawingX / totalLengthX);
          const scaledYFin = paddingY + (value.yFin * meshDrawingY / totalLengthY);
          result.push({
            xDeb: scaledXDeb,
            yDeb: scaledYDeb,
            xFin: scaledXFin,
            yFin: scaledYFin
          });
        });
        return result;
      }

      // Fonction pour redimentioner les suites de ligne par rapport à la taille du canvas
      function convertMeshDrawingLineToPath2D(meshDrawingLine: MeshDrawingLine[]): Path2D {
          const result: Path2D = new Path2D();
          meshDrawingLine.forEach(value => {
              result.moveTo(value.xDeb, value.yDeb);
              result.lineTo(value.xFin, value.yFin);
          });
          return result;
      }

      // Vertical, les barres placé de gauche à droite, !! on prend le début et le fin de l'horizontal !!
      const separatorVertical = (totalLengthX - horizontalMeshValue.startValue - horizontalMeshValue.endValue) / (verticalMeshValue.nbBar - 1);
      const startOffsetVertical = separatorVertical * (verticalMeshValue.startValue / horizontalMeshValue.step);
      for (let i = 0 ; i < verticalMeshValue.nbBar ; i++) {
          const X = (i * separatorVertical) + startOffsetVertical;
          arrayLineVertical.push({
              xDeb: X,
              yDeb: 0,
              xFin: X,
              yFin: totalLengthY
          });
      }

      // Horizontal les barres placé de haut enbas, !! on prend le début et le fin de la vertical !!
      const separatorHorizontal = (totalLengthY - verticalMeshValue.startValue - verticalMeshValue.endValue) / (horizontalMeshValue.nbBar - 1);
      const startOffsetHorizontal = separatorHorizontal * (horizontalMeshValue.startValue / verticalMeshValue.step);
      for (let i = 0 ; i < horizontalMeshValue.nbBar ; i++) {
          const Y = (i * separatorHorizontal) + startOffsetHorizontal;
          arrayLineHorizontal.push({
              xDeb: 0,
              yDeb: Y,
              xFin: totalLengthX,
              yFin: Y
          });
      }

      // Info en plus a afficher dans le canvas du mesh
      // ....
    // On converti les lignes à la taille du canvas
    const scaledArrayLineVertical: MeshDrawingLine[] = scaleMeshDrawingLines(arrayLineVertical);
    const scaledArrayLineHorizontal: MeshDrawingLine[] = scaleMeshDrawingLines(arrayLineHorizontal);
      return {
          Vertical: convertMeshDrawingLineToPath2D(scaledArrayLineVertical),
          Horizontal: convertMeshDrawingLineToPath2D(scaledArrayLineHorizontal),
          verticalLines: scaledArrayLineVertical,
          horizontalLines: scaledArrayLineHorizontal
      };
  }

  private static drawInfoMesh(canvasContext: CanvasRenderingContext2D, canvasHeight: number, canvasWidth: number) {
      // On garde 5% du canvas sur chaque coté pour pouvoir desiner des informations en plus
      const meshDrawingX = canvasWidth * WMeshUtils.RATIO_MESH;
      const meshDrawingY = canvasHeight * WMeshUtils.RATIO_MESH;

      // un coté de surface pour dessiné les infos
      const paddingX = (canvasWidth * WMeshUtils.RATIO_INFO) / 2;
      const paddingY = (canvasHeight * WMeshUtils.RATIO_INFO) / 2;

      const centerPadingX = paddingX / 2;
      const centerPadingY = paddingY / 2;

      // Debug
      const path2d = new Path2D();
      path2d.moveTo(0, 0);
      path2d.lineTo(meshDrawingX + (paddingX * 2), 0);
      path2d.lineTo(meshDrawingX + (paddingX * 2), meshDrawingX + (paddingY * 2));
      path2d.lineTo(0, meshDrawingX + (paddingY * 2));
      path2d.lineTo(0, 0);

      path2d.moveTo(paddingX, paddingY);
      path2d.lineTo(meshDrawingX + paddingX, paddingY);
      path2d.lineTo(meshDrawingX + paddingX, meshDrawingY + paddingY);
      path2d.lineTo(paddingX, meshDrawingY + paddingY);
      path2d.lineTo(paddingX, paddingY);

      canvasContext.stroke(path2d);
  }

  private static getDefaultMeshValue(): WMeshAxesInformation {
      return {
          nbBar: 5,
          step: 30,
          startValue: 10,
          endValue: 10
      };
  }

  private static drawMeshDistribution(context2D: CanvasRenderingContext2D,
                                      meshDrawingInfo: MeshDrawingInfo,
                                      verticalLines: MeshDrawingLine[],
                                      horizontalLines: MeshDrawingLine[],
                                      pos: number,
                                      vertical: boolean) {
    const path: Path2D = new Path2D();
    let textOnTop = true;
    const lines = vertical ? verticalLines : horizontalLines;
    const otherLines = vertical ? horizontalLines : verticalLines;
    const axesInformation = vertical ? meshDrawingInfo.horizontalMeshInfo : meshDrawingInfo.verticalMeshInfo;
    const otherAxesInformation = vertical ? meshDrawingInfo.verticalMeshInfo : meshDrawingInfo.horizontalMeshInfo;

    function getTextOffset(): number {
      return textOnTop ? - textOffset : textOffset;
    }
    if (vertical) {
      path.moveTo(pos, lines[0].yDeb);
      path.lineTo(pos, lines[lines.length - 1].yFin);
    } else {
      path.moveTo(lines[0].xDeb, pos);
      path.lineTo(lines[lines.length - 1].xFin, pos);
    }
    const offset = 3;
    const textOffset = 12;

    // Start offset
    if (vertical) {
      CUtilitDrawing.drawBoxText(context2D, otherAxesInformation.startValue.toString(), pos + getTextOffset(), (otherLines[0].yDeb - lines[0].yDeb) / 2 + lines[0].yDeb, -90);
    } else {
      CUtilitDrawing.drawBoxText(context2D, otherAxesInformation.startValue.toString(), (otherLines[0].xDeb - lines[0].xDeb) / 2 + lines[0].xDeb, pos + getTextOffset());
    }
    textOnTop = !textOnTop;
    // Distribution
    for (let i = 0; i < otherLines.length; i++) {
      if (vertical) {
        path.moveTo(pos - offset, otherLines[i].yFin);
        path.lineTo(pos + offset, otherLines[i].yFin);
      } else {
        path.moveTo(otherLines[i].xFin, pos - offset);
        path.lineTo(otherLines[i].xFin, pos + offset);
      }
    }
    const distributionText = (axesInformation.nbBar - 1).toString() + ' x ' + axesInformation.step.toString();
    if (vertical) {
      const middle = otherLines[0].yDeb - (otherLines[0].yDeb - otherLines[otherLines.length - 1].yFin) / 2;
      CUtilitDrawing.drawBoxText(context2D, distributionText, pos + getTextOffset(), middle, -90);
    } else {
      const middle = otherLines[0].xDeb - (otherLines[0].xDeb - otherLines[otherLines.length - 1].xFin) / 2;
      CUtilitDrawing.drawBoxText(context2D, distributionText, middle, pos + getTextOffset());
    }
    textOnTop = !textOnTop;
    // End offset
    if (vertical) {
      CUtilitDrawing.drawBoxText(context2D,
                       otherAxesInformation.endValue.toString(),
                    pos + getTextOffset(),
                    (otherLines[otherLines.length - 1].yFin - lines[lines.length - 1].yFin) / 2 + lines[lines.length - 1].yFin,
                -90);
    } else {
      CUtilitDrawing.drawBoxText(context2D,
                       otherAxesInformation.endValue.toString(),
                    (otherLines[otherLines.length - 1].xFin - lines[lines.length - 1].xFin) / 2 + lines[lines.length - 1].xFin,
                    pos + getTextOffset()
      );
    }
    context2D.stroke(path);
  }

  private static drawMeshHelpDimensionArrow(canvasContext: CanvasRenderingContext2D,
                                            meshDrawingInfo: MeshDrawingInfo,
                                            verticalLines: MeshDrawingLine[],
                                            horizontalLines: MeshDrawingLine[],
                                            bDrawHeight: boolean) {
    const path: Path2D = new Path2D();
    // Height helper arrow
    const heightStart: Point2D = new Point2D(20, verticalLines[0].yDeb);
    const heightEnd: Point2D = new Point2D(20, verticalLines[0].yFin);
    // Width helper arrow
    const widthStart: Point2D = new Point2D(horizontalLines[0].xDeb, canvasContext.canvas.height - 10);
    const widthEnd: Point2D = new Point2D(horizontalLines[0].xFin, canvasContext.canvas.height - 10);
    // Dessin de la flèche
    if (bDrawHeight) {
      CUtilitDrawing.drawArrow(path, widthStart, widthEnd, 5, true);
    } else {
      CUtilitDrawing.drawArrow(path, heightStart, heightEnd, 5, true);
    }
    // Calcul de la longueur totale du treillis
    const totalWidth = meshDrawingInfo.horizontalMeshInfo.startValue + (meshDrawingInfo.verticalMeshInfo.nbBar - 1) * meshDrawingInfo.verticalMeshInfo.step + meshDrawingInfo.horizontalMeshInfo.endValue;
    const totalHeight = meshDrawingInfo.verticalMeshInfo.startValue + (meshDrawingInfo.horizontalMeshInfo.nbBar - 1) * meshDrawingInfo.horizontalMeshInfo.step + meshDrawingInfo.verticalMeshInfo.endValue;
    canvasContext.stroke(path);
    // Drawing the text for the width and height after the arrows
    canvasContext.font = '16px Arial';
    if (bDrawHeight) {
      CUtilitDrawing.drawBoxText(canvasContext, meshDrawingInfo.virtualDrawing ? '?' : totalWidth.toString(),
        widthStart.X + (widthEnd.X - widthStart.X) / 2,
        widthStart.Y + (widthEnd.Y - widthStart.Y) / 2
      );
    } else {
      CUtilitDrawing.drawBoxText(canvasContext, meshDrawingInfo.virtualDrawing ? '?' : totalHeight.toString(),
        heightStart.X + (heightEnd.X - heightStart.X) / 2,
        heightStart.Y + (heightEnd.Y - heightStart.Y) / 2,
        - 90
      );
    }
  }

  /**
   * @param virtualMode sert à savoir si on déssine pour des lignes virtuelles avec de fausses dimensions
   */
  private static drawMeshHelpInfo(canvasContext: CanvasRenderingContext2D,
                                  meshDrawingInfo: MeshDrawingInfo,
                                  verticalLines: MeshDrawingLine[],
                                  horizontalLines: MeshDrawingLine[],
                                  virtualMode: boolean = false) {
    canvasContext.save();
    canvasContext.shadowBlur = 0;
    canvasContext.shadowOffsetX = 0;
    canvasContext.shadowOffsetY = 0;
    canvasContext.strokeStyle = '#000000';
    // Drawing of the full dimension arrows (width / height)
    if (!meshDrawingInfo.virtualDrawing) {
      this.drawMeshHelpDimensionArrow(canvasContext, meshDrawingInfo, verticalLines, horizontalLines, false);
      this.drawMeshHelpDimensionArrow(canvasContext, meshDrawingInfo, verticalLines, horizontalLines, true);
    }
    // Drawing the distribution
    if (!meshDrawingInfo.virtualDrawing) {
      this.drawMeshDistribution(canvasContext, meshDrawingInfo, verticalLines, horizontalLines, 50, true);
      this.drawMeshDistribution(canvasContext, meshDrawingInfo, verticalLines, horizontalLines, canvasContext.canvas.height - 40, false);
    }
    canvasContext.restore();
  }
  private static drawMeshHelper(canvasContext: CanvasRenderingContext2D,
                                inputHelperId: string,
                                meshDrawingInfo: MeshDrawingInfo,
                                verticalLines: MeshDrawingLine[],
                                horizontalLines: MeshDrawingLine[]) {
    canvasContext.save();
    try {
      const path: Path2D = new Path2D();
      const bVertical = inputHelperId.endsWith('Vertical');
      const meshLines: MeshDrawingLine[] = bVertical ? verticalLines : horizontalLines;
      const otherMeshLines: MeshDrawingLine[] = bVertical ? horizontalLines : verticalLines;
      const boxWidth = 20;
      const boxHeight = 12;
      let questionMarkX = horizontalLines[0].xDeb + (horizontalLines[0].xFin - horizontalLines[0].xDeb) / 2;
      let questionMarkY = 12;
      let boxAnchorX = 0;
      let boxAnchorY = 0;
      canvasContext.lineWidth = 2;
      canvasContext.strokeStyle = '#26CC26';
      canvasContext.fillStyle = '#26CC26';
      canvasContext.setLineDash([3]);

      function showLengthBetweenBars(posBegin: Point2D, posEnd: Point2D, straight: boolean = false, bFlipCurve: boolean = false) {
        const posMiddle = new Point2D(posBegin.X + (posEnd.X - posBegin.X) / 2,
                                      posBegin.Y + (posEnd.Y - posBegin.Y) / 2);
        const radius = Math.sqrt(Math.pow(posEnd.Y - posBegin.Y, 2) + Math.pow(posEnd.X - posBegin.X, 2)) / 2;
        if (bVertical) {
          posMiddle.Y = posMiddle.Y + (bFlipCurve ? Math.min(radius, 20) : - Math.min(radius, 20));
        } else {
          posMiddle.X = posMiddle.X + (bFlipCurve ? Math.min(radius, 20) : - Math.min(radius, 20));
        }
        path.moveTo(posBegin.X, posBegin.Y);
        if (straight) {
          path.lineTo(posEnd.X, posEnd.Y);
        } else {
          path.quadraticCurveTo(posMiddle.X, posMiddle.Y, posEnd.X, posEnd.Y);
        }
      }
      let posStart: Point2D = new Point2D(0, 0);
      let posEnd: Point2D = new Point2D(0, 0);

      switch (inputHelperId) {
        case 'nb-Bars-Vertical':
        case 'nb-Bars-Horizontal':
          const textMeasure = canvasContext.measureText('?');
          if (inputHelperId == 'nb-Bars-Horizontal') {
            questionMarkX = 36;
            questionMarkY = verticalLines[0].yDeb + (verticalLines[0].yFin - verticalLines[0].yDeb) / 2;
          }
          CUtilitDrawing.drawBoxText(canvasContext, '?', questionMarkX, questionMarkY, 0, true);
          meshLines.forEach(meshLine => {
            boxAnchorX = questionMarkX - (boxWidth / 2);
            boxAnchorY = questionMarkY + boxHeight;
            if (inputHelperId == 'nb-Bars-Horizontal') {
              boxAnchorX = questionMarkX;
              boxAnchorY = questionMarkY + boxHeight / 2;
            }
            path.moveTo(boxAnchorX, boxAnchorY);
            path.lineTo(meshLine.xDeb, meshLine.yDeb);
          });
          break;
        case 'step-Vertical':
        case 'step-Horizontal':
          for (let i = 0; i < meshLines.length - 1; i++) {
            showLengthBetweenBars(new Point2D(meshLines[i].xDeb, meshLines[i].yDeb),
                                  new Point2D(meshLines[i + 1].xDeb, meshLines[i + 1].yDeb));
          }
          break;
        case 'diameter-Vertical':
        case 'diameter-Horizontal':
          console.log('TEST : ' + meshLines.length);
          canvasContext.setLineDash([]);
          meshLines.forEach(meshLine => {
            path.moveTo(meshLine.xDeb, meshLine.yDeb);
            path.lineTo(meshLine.xFin, meshLine.yFin);
          });
          break;
        case 'start-Measure-Vertical':
        case 'start-Measure-Horizontal':
          posStart = new Point2D(meshLines[0].xDeb, meshLines[0].yDeb);
          posEnd = new Point2D(otherMeshLines[0].xDeb, otherMeshLines[0].yDeb);
          if (bVertical) {
            posEnd.Y = meshLines[0].yDeb;
          } else {
            posEnd.X = meshLines[0].xDeb;
          }
          showLengthBetweenBars(posStart, posEnd);
          break;
        case 'end-Measure-Vertical':
        case 'end-Measure-Horizontal':
          posStart = new Point2D(meshLines[meshLines.length - 1].xFin, meshLines[meshLines.length - 1].yDeb);
          posEnd = new Point2D(otherMeshLines[0].xFin, otherMeshLines[0].yFin);
          if (bVertical) {
            posEnd.Y = meshLines[meshLines.length - 1].yDeb;
          } else {
            posStart.X = meshLines[meshLines.length - 1].xDeb;
            posEnd.X = meshLines[0].xDeb;
          }
          showLengthBetweenBars(posStart, posEnd, false);
          break;
        case 'total-length-Vertical':
        case 'total-length-Horizontal':
          this.drawMeshHelpDimensionArrow(canvasContext, meshDrawingInfo, verticalLines, horizontalLines, bVertical);
          break;
      }
      canvasContext.stroke(path);
    } finally {
      canvasContext.restore();
    }
  }

  public static drawMesh(htmlCanvas: HTMLCanvasElement,
                         verticalMeshValue: WMeshAxesInformation,
                         horizontalMeshValue: WMeshAxesInformation,
                         fromDefaultValue: boolean = false,
                         inputHelperId: string = '',
                         drawHelpInfo: boolean = false) {
    // Pour sécurité
    if (!WMeshUtils.isMeshValuesCorrect(verticalMeshValue) || !WMeshUtils.isMeshValuesCorrect(horizontalMeshValue)) {
      if (!fromDefaultValue)
        this.drawMesh(htmlCanvas, WMeshUtils.getDefaultMeshValue(), WMeshUtils.getDefaultMeshValue(), true, inputHelperId, drawHelpInfo);
      else
        console.error('Unable to draw with default value');
      return;
    }
    const meshDrawingInfo: MeshDrawingInfo = { horizontalMeshInfo: horizontalMeshValue, verticalMeshInfo: verticalMeshValue, virtualDrawing: fromDefaultValue };
    const canvasHeight: number = htmlCanvas.height;
    const canvasWidth: number = htmlCanvas.width;
    const meshDrawRect: Rect = { left: 0, top: 0, bottom: canvasHeight, right: canvasWidth };
    if (drawHelpInfo) {
      meshDrawRect.top = 20;
      meshDrawRect.left = 40;
      meshDrawRect.bottom = canvasHeight - 40;
    }

    const canvasContext: CanvasRenderingContext2D | null = htmlCanvas.getContext('2d');
    if (canvasContext == null)
      return;
    canvasContext.lineWidth = 2;
    canvasContext.shadowOffsetX = 2;
    canvasContext.shadowOffsetY = 2;
    canvasContext.shadowColor = '#696969';
    canvasContext.shadowBlur = 5;

    // On recuperer tout les point a afficher dans le canvas
    const path2d = WMeshUtils.getMeshPath2D(meshDrawRect, verticalMeshValue, horizontalMeshValue);

    canvasContext.strokeStyle = '#FF2626';
    canvasContext.stroke(path2d.Horizontal);
    canvasContext.strokeStyle = '#4a79d9';
    canvasContext.stroke(path2d.Vertical);

    if (drawHelpInfo) {
      canvasContext.save();
      try {
        canvasContext.lineWidth = 1;
        canvasContext.fillStyle = '#fff';
        canvasContext.fillStyle = '#000';
        this.drawMeshHelpInfo(canvasContext, meshDrawingInfo, path2d.verticalLines, path2d.horizontalLines);
        if (inputHelperId != '') {
          this.drawMeshHelper(canvasContext, inputHelperId, meshDrawingInfo, path2d.verticalLines, path2d.horizontalLines);
        }
      } finally {
        canvasContext.restore();
      }
    }
  }
}
